import type React from 'react';

import type { VCSHost } from '../../../../shared/projectsV2/vcs';
import type { Team, UpdateHook } from '../../../types';
import type { IconType } from '../../generic';

import { AzureLogo } from './icons';

export type ServiceVCS = VCSHost | 'manual';

export type ServiceMetadata = {
  icon?: IconType;
  SVGIcon?: React.FunctionComponent;
  color: string;
  label: string;
  displayName: string;
  docsURL?: string;
  docsLinkText?: string;
  authNote?: string;
};

export const ServiceMeta: Record<ServiceVCS, ServiceMetadata> = {
  github: {
    icon: 'github',
    color: '#3a3a3a',
    label: 'GitHub',
    displayName: 'GitHub',
    docsURL: 'https://docs.fossa.com/docs/github',
    docsLinkText: 'How to Authorize Access',
    authNote: 'If you don\u2019t see an organization listed, you may need to grant FOSSA access to it in GitHub\u2019s settings.',
  },
  'github-app': {
    icon: 'github',
    color: '#3a3a3a',
    label: 'GitHub App',
    displayName: 'GitHub App',
    docsURL: 'https://docs.fossa.com/docs/github',
    docsLinkText: 'How to Authorize Access',
    authNote: 'If you don\u2019t see an organization listed, you may need to install the FOSSA GitHub App and link it to FOSSA.',
  },
  bitbucket_server: {
    icon: 'bitbucket',
    color: '#305178',
    label: 'Server',
    displayName: 'Bitbucket Server',
    docsURL: 'https://docs.fossa.com/docs/bitbucket-server-stash',
    docsLinkText: 'Bitbucket On-Prem Setup',
  },
  bitbucket_cloud: {
    icon: 'bitbucket',
    color: '#305178',
    label: 'Bitbucket',
    displayName: 'Bitbucket Cloud',
    authNote: 'If you don\u2019t see a team listed, you may need to grant FOSSA access to it in Bitbucket\u2019s settings.',
  },
  gitlab: {
    icon: 'gitlab',
    color: '#d4361a',
    label: 'Gitlab',
    displayName: 'Gitlab',
    authNote: 'If you don\u2019t see a group listed, you may need to grant FOSSA access to it in GitLab\u2019s settings.',
  },
  manual: {
    icon: 'globe',
    color: '#777',
    label: 'Manual',
    displayName: 'Manual',
  },
  azure_repos: {
    SVGIcon: AzureLogo,
    color: '#0078D4',
    label: 'Azure Repos',
    displayName: 'Azure Repos',
    authNote: 'If you don\u2019t see a team listed, you may need to grant FOSSA access to it in Azure DevOps\u2019 settings.',
  },
};

type ScanMethodProjectOverrides = {
  quickImportVendoredDetectionEnabled: boolean;
  quickImportSnippetDetectionEnabled: boolean;
};

export type ScanMethodSelections = ScanMethodProjectOverrides & {
  // Frontend-only control flag: when true, ServiceImport.onImport PUTs the
  // selected defaults to the org's quick-import-scan-methods settings after
  // the import. Stripped from options before the /import POST body.
  quickImportShouldSavePreference: boolean;
};

export type ProjectImportOptions = {
  policy_notifications?: string;
  policy_update?: string;
  policy_access?: string;
  update_hook?: UpdateHook;
  send_badge_pr?: boolean;
  selectedTeams?: Team[];
} & Partial<ScanMethodSelections>;
